<template>
  <div>
    <label v-if="label" class="mr-1 text-size-14 text-mild">{{ label }}</label>
    <AppLabel variant="red" v-if="appLabelText">{{ appLabelText }}</AppLabel>
    <AppTextArea
      :value="value"
      :validation-state="validationState"
      :placeholder="placeholder"
      :rows="rows"
      :maxRows="maxRows"
      :enableAutoResize="enableTextareaAutoResize"
      @input="onInput"
      @blur="onBlur"
    />
    <FormInvalidFeedback :validation-state="validationState" :state="false" />
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-facing-decorator";
import AppTextArea from "@/components/atoms/input/AppTextArea.vue";
import FormInvalidFeedback from "@/components/atoms/other/FormInvalidFeedback.vue";
import AppLabel from "@/components/atoms/input/AppLabel.vue";

type ValidationStateType = {
  validated: boolean;
  valid: boolean | undefined;
};

@Component({
  components: {
    AppTextArea,
    FormInvalidFeedback,
    AppLabel
  }
})
export default class TextAreaGroup extends Vue {
  @Prop({
    type: String || Number,
    required: true,
    default: ""
  })
  value!: string | number;

  @Prop({
    type: String,
    default: ""
  })
  label!: string;

  @Prop({
    type: String,
    default: ""
  })
  placeholder!: string;

  @Prop({
    type: String,
    default: ""
  })
  appLabelText!: string;

  @Prop({
    type: Object,
    default: () => ({})
  })
  validationState!: ValidationStateType;

  @Prop({
    type: [String, Number]
  })
  rows!: string | number;

  @Prop({
    type: [String, Number]
  })
  maxRows!: string | number;

  @Prop({
    type: Boolean,
    default: false
  })
  enableTextareaAutoResize!: boolean;

  onInput(v: string) {
    this.$emit("input", v);
  }

  onBlur(v: string) {
    this.$emit("blur", v);
  }
}
</script>
<style lang="scss" scoped>
label {
  margin-bottom: 6px;
}
</style>
